/** Klien API katalog publik: tenant, layanan, dan slot ketersediaan. */

import { api } from "./client";
import type { Gender, ServicePublic, TenantPublic } from "./types";

/** Detail tenant dari GET /tenants/:slug (full record, termasuk email/timezone). */
export interface TenantDetail extends TenantPublic {
  email: string | null;
  timezone: string;
  status: string;
}

/**
 * Slot ketersediaan ANONIM: pasien tidak memilih terapis, sistem yang menetapkan.
 * `therapistCount` = jumlah terapis berdinas yang masih bebas pada jam tersebut.
 */
export interface AvailabilitySlot {
  startTime: string; // "HH:mm"
  endTime: string; // "HH:mm"
  therapistCount: number;
}

export interface AvailabilityService {
  id: string;
  name: string;
  durationMinutes: number;
  price: number;
}

export interface AvailabilityResponse {
  date: string; // "YYYY-MM-DD"
  service: AvailabilityService;
  slots: AvailabilitySlot[];
  therapistCount: number;
}

export function fetchTenants(): Promise<TenantPublic[]> {
  return api.get<{ tenants: TenantPublic[] }>("/tenants").then((res) => res.tenants);
}

export function fetchTenant(slug: string): Promise<TenantDetail> {
  return api.get<{ tenant: TenantDetail }>(`/tenants/${slug}`).then((res) => res.tenant);
}

export function fetchServices(slug: string): Promise<ServicePublic[]> {
  return api
    .get<{ services: ServicePublic[] }>(`/tenants/${slug}/services`)
    .then((res) => res.services);
}

export function fetchAvailability(
  slug: string,
  params: { serviceId: string; date: string; gender?: Gender | null },
): Promise<AvailabilityResponse> {
  const search = new URLSearchParams({
    serviceId: params.serviceId,
    date: params.date,
  });
  // Tanpa gender (belum login / belum diisi) server menghitung semua terapis.
  if (params.gender) search.set("gender", params.gender);
  return api
    .get<AvailabilityResponse>(`/tenants/${slug}/availability?${search.toString()}`)
    .then((res) => res);
}
